import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import mailReducer from './slices/mail';
import chatReducer from './slices/chat';
import productReducer from './slices/product';
import calendarReducer from './slices/calendar';
import kanbanReducer from './slices/kanban';
import Notification from './slices/notification';
import pApp from './slices/publicAppointment';
import nL from './slices/newslatter';
import bulkSms from './slices/bulkSms';
import subscriberList from './slices/subscribers-list';

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout'],
};

const rootReducer = combineReducers({
  mail: mailReducer,
  chat: chatReducer,
  calendar: calendarReducer,
  kanban: kanbanReducer,
  notifications: Notification,
  product: persistReducer(productPersistConfig, productReducer),
  publicAppointment: pApp,
  newsLetter: nL,
  bulkSms,
  subscriberList
});

export { rootPersistConfig, rootReducer };
